(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-hover-gallery-card"] && !Shopify.designMode) return;
  try {
    (function () {

  /* Prevent duplicate initialization */
  if (window.__ZASTA_HGALLERY_CART_INIT__) {
    return;
  }

  window.__ZASTA_HGALLERY_CART_INIT__ = true;


  /* =====================================================
     HOVER GALLERY
  ===================================================== */

  document.addEventListener('mouseover', function (e) {

    var zone = e.target.closest('.hgallery__zone');

    if (!zone) {
      return;
    }

    var gallery = zone.closest('[data-hgallery]');

    if (!gallery) {
      return;
    }

    var index = parseInt(zone.dataset.index, 10);

    var images = gallery.querySelectorAll('.hgallery__img');
    var dots = gallery.querySelectorAll('.hgallery__dot');

    images.forEach(function (image, i) {

      image.classList.toggle(
        'is-active',
        i === index
      );

    });

    dots.forEach(function (dot, i) {

      dot.classList.toggle(
        'is-active',
        i === index
      );

    });

  });


  /* =====================================================
     RESET GALLERY
  ===================================================== */

  document.addEventListener('mouseout', function (e) {

    var gallery = e.target.closest('[data-hgallery]');

    if (!gallery) {
      return;
    }

    if (gallery.contains(e.relatedTarget)) {
      return;
    }

    var images = gallery.querySelectorAll('.hgallery__img');
    var dots = gallery.querySelectorAll('.hgallery__dot');

    images.forEach(function (image, i) {

      image.classList.toggle(
        'is-active',
        i === 0
      );

    });

    dots.forEach(function (dot, i) {

      dot.classList.toggle(
        'is-active',
        i === 0
      );

    });

  });


  /* =====================================================
     GET CART DRAWER
  ===================================================== */

  function getCartDrawer() {

    return (
      document.querySelector('#CartDrawer') ||
      document.querySelector('[data-target="CartDrawer"]')?.closest(
        '[id="CartDrawer"]'
      ) ||
      document.querySelector('cart-drawer') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('.cart-drawer')
    );

  }


  /* =====================================================
     UPDATE CART COUNT
  ===================================================== */

  function updateCartCount(cart) {

    if (!cart) {
      return;
    }

    var count = parseInt(cart.item_count, 10) || 0;

    document
      .querySelectorAll('.js-header-cart-item-count')
      .forEach(function (element) {

        element.textContent =
          count > 99 ? '99+' : count;

        element.setAttribute(
          'data-cart-count',
          count
        );

        if (count > 0) {

          element.style.display = '';

          element.classList.remove('hidden');

        } else {

          element.style.display = 'none';

        }

      });


    document
      .querySelectorAll('[data-cart-count]')
      .forEach(function (element) {

        element.setAttribute(
          'data-cart-count',
          count
        );

      });

  }


  /* =====================================================
     GET CURRENT CART
  ===================================================== */

  function getCart() {

    return fetch(
      window.Shopify.routes.root + 'cart.js',
      {
        method: 'GET',

        credentials: 'same-origin',

        headers: {
          'Accept': 'application/json'
        },

        cache: 'no-store'
      }
    )
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Cart could not be loaded.'
        );
      }

      return response.json();

    });

  }





  /* =====================================================
   FORCE LOAD CART DRAWER IMAGES
   ===================================================== */

function loadCartDrawerImages(drawer) {

  if (!drawer) {
    return;
  }

  var images =
    drawer.querySelectorAll('img');

  images.forEach(function (img) {

    /* ---------------------------------------------
       Get real image URL from lazy-load attributes
    --------------------------------------------- */

    var realSrc =
      img.getAttribute('data-src') ||
      img.getAttribute('data-original') ||
      img.getAttribute('data-lazy-src');

    var realSrcset =
      img.getAttribute('data-srcset') ||
      img.getAttribute('data-lazy-srcset');


    /* ---------------------------------------------
       Apply real src
    --------------------------------------------- */

    if (realSrc) {

      img.setAttribute(
        'src',
        realSrc
      );

      img.removeAttribute(
        'data-src'
      );

      img.removeAttribute(
        'data-original'
      );

      img.removeAttribute(
        'data-lazy-src'
      );

    }


    /* ---------------------------------------------
       Apply real srcset
    --------------------------------------------- */

    if (realSrcset) {

      img.setAttribute(
        'srcset',
        realSrcset
      );

      img.removeAttribute(
        'data-srcset'
      );

      img.removeAttribute(
        'data-lazy-srcset'
      );

    }


    /* ---------------------------------------------
       Disable lazy loading
    --------------------------------------------- */

    img.loading = 'eager';

    img.setAttribute(
      'loading',
      'eager'
    );

    img.setAttribute(
      'decoding',
      'async'
    );


    /* ---------------------------------------------
       Remove common lazy classes
    --------------------------------------------- */

    img.classList.remove('lazyload');
    img.classList.remove('lazy');
    img.classList.remove('lazyloaded');


    /* ---------------------------------------------
       Make image visible
    --------------------------------------------- */

    img.style.visibility = 'visible';
    img.style.opacity = '1';
    img.style.display = 'block';


    /* ---------------------------------------------
       Force browser to load image
    --------------------------------------------- */

    var src =
      img.getAttribute('src');

    if (src) {

      img.src = src;

    }

  });


  /* ---------------------------------------------
     Run again after browser paints DOM
  --------------------------------------------- */

  requestAnimationFrame(function () {

    images.forEach(function (img) {

      if (
        img.complete &&
        img.naturalWidth === 0
      ) {

        var src =
          img.getAttribute('src');

        if (src) {

          img.src = src;

        }

      }

    });

  });

}
  /* =====================================================
     REFRESH CART DRAWER
     
     IMPORTANT:
     We do NOT replace the complete cart drawer.
     
     We update the existing drawer's HTML instead.
  ===================================================== */

  function refreshCartDrawer() {

    return fetch(
      window.Shopify.routes.root +
      '?sections=cart-drawer&_=' +
      Date.now(),
      {
        method: 'GET',

        credentials: 'same-origin',

        headers: {
          'Accept': 'application/json'
        },

        cache: 'no-store'
      }
    )
    .then(function (response) {

      if (!response.ok) {

        throw new Error(
          'Cart drawer could not be refreshed.'
        );

      }

      return response.json();

    })
    .then(function (sections) {

      var html = sections['cart-drawer'];

      if (!html) {

        console.warn(
          'Shopify cart-drawer section was not returned.'
        );

        return false;

      }


      var parser = new DOMParser();

      var documentHTML = parser.parseFromString(
        html,
        'text/html'
      );


      /*
       * Find returned drawer.
       */

      var newDrawer =
        documentHTML.querySelector('#CartDrawer') ||
        documentHTML.querySelector('cart-drawer') ||
        documentHTML.querySelector('[data-cart-drawer]') ||
        documentHTML.querySelector('.cart-drawer');


      /*
       * Find current drawer.
       */

      var oldDrawer =
        document.querySelector('#CartDrawer') ||
        document.querySelector('cart-drawer') ||
        document.querySelector('[data-cart-drawer]') ||
        document.querySelector('.cart-drawer');


      if (!newDrawer) {

        console.warn(
          'New cart drawer element was not found.'
        );

        return false;

      }


      if (!oldDrawer) {

        console.warn(
          'Current cart drawer element was not found.'
        );

        return false;

      }


      /*
       * IMPORTANT:
       *
       * Instead of replacing the custom element itself,
       * replace its inner HTML.
       *
       * This prevents the theme's CartDrawer JS
       * from getting destroyed.
       */

      oldDrawer.innerHTML =
        newDrawer.innerHTML;


      /* =====================================================
        IMPORTANT:
        FORCE CART PRODUCT IMAGES TO LOAD AFTER AJAX
        ===================================================== */

      loadCartDrawerImages(oldDrawer);


      /* Run once more after DOM repaint */

      setTimeout(function () {

        loadCartDrawerImages(oldDrawer);

      }, 100);

      /*
       * Copy useful state attributes.
       */

      if (
        newDrawer.hasAttribute('open')
      ) {

        oldDrawer.setAttribute(
          'open',
          ''
        );

      }


      if (
        newDrawer.hasAttribute('aria-hidden')
      ) {

        oldDrawer.setAttribute(
          'aria-hidden',
          newDrawer.getAttribute(
            'aria-hidden'
          )
        );

      }


      /*
       * Update classes from new drawer.
       */

      var newClasses =
        newDrawer.className;

      if (
        typeof newClasses === 'string'
      ) {

        oldDrawer.className =
          newClasses;

      }


      return true;

    });

  }


  /* =====================================================
     OPEN CART DRAWER
     
     Your theme already has:
     
     data-target="CartDrawer"
     data-js-toggle="CartDrawer"
     
     So FIRST use the theme's own cart button.
  ===================================================== */

  function openCartDrawer() {

    var cartButton =
      document.querySelector(
        '[data-js-toggle="CartDrawer"]'
      );


    if (cartButton) {

      /*
       * Let the theme handle opening.
       *
       * This is much safer than manually
       * adding random drawer classes.
       */

      cartButton.click();

      return true;

    }


    /*
     * Fallback for custom cart drawer.
     */

    var drawer =
      document.querySelector('#CartDrawer') ||
      document.querySelector('cart-drawer');


    if (!drawer) {
      return false;
    }


    if (
      typeof drawer.open === 'function'
    ) {

      try {

        drawer.open();

        return true;

      } catch (error) {}

    }


    if (
      typeof drawer.show === 'function'
    ) {

      try {

        drawer.show();

        return true;

      } catch (error) {}

    }


    drawer.setAttribute(
      'open',
      ''
    );

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    drawer.classList.add(
      'is-open'
    );

    drawer.classList.add(
      'active'
    );

    return true;

  }


  /* =====================================================
     CART UPDATE EVENTS
  ===================================================== */

  function notifyCartUpdated(cart) {

    document.dispatchEvent(
      new CustomEvent(
        'cart:updated',
        {
          bubbles: true,
          detail: {
            cart: cart
          }
        }
      )
    );


    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          bubbles: true,
          detail: {
            cart: cart
          }
        }
      )
    );


    document.dispatchEvent(
      new CustomEvent(
        'cart:change',
        {
          bubbles: true,
          detail: {
            cart: cart
          }
        }
      )
    );

  }


  /* =====================================================
     ADD TO CART
  ===================================================== */

  document.addEventListener(
    'click',
    function (e) {

      var button =
        e.target.closest(
          '[data-hgallery-atc]'
        );


      if (!button) {
        return;
      }


      /*
       * VERY IMPORTANT:
       *
       * Button is inside product link.
       * Stop the parent <a> from navigating.
       */

      e.preventDefault();

      e.stopPropagation();


      if (
        button.disabled ||
        button.classList.contains(
          'is-loading'
        )
      ) {

        return;

      }


      var variantId =
        button.dataset.variantId;


      if (!variantId) {

        console.error(
          'Zasta Cart: Variant ID missing.'
        );

        return;

      }


      var originalText =
        button.textContent.trim();


      /* -------------------------------------------------
         LOADING
      ------------------------------------------------- */

      button.classList.add(
        'is-loading'
      );

      button.classList.remove(
        'is-added'
      );

      button.classList.remove(
        'is-error'
      );

      button.textContent =
        'Adding...';


      /* -------------------------------------------------
         ADD TO CART
      ------------------------------------------------- */

      fetch(
        window.Shopify.routes.root +
        'cart/add.js',
        {
          method: 'POST',

          credentials: 'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'
          },

          body: JSON.stringify({

            items: [

              {
                id: Number(variantId),

                quantity: 1
              }

            ]

          })

        }
      )


      /* -------------------------------------------------
         CHECK ADD RESPONSE
      ------------------------------------------------- */

      .then(function (response) {

        if (!response.ok) {

          return response
            .json()
            .then(function (error) {

              throw error;

            });

        }

        return response.json();

      })


      /* -------------------------------------------------
         GET UPDATED CART
      ------------------------------------------------- */

      .then(function () {

        return getCart();

      })


      /* -------------------------------------------------
         UPDATE COUNT
      ------------------------------------------------- */

      .then(function (cart) {

        updateCartCount(cart);

        notifyCartUpdated(cart);


        button.classList.remove(
          'is-loading'
        );

        button.classList.add(
          'is-added'
        );

        button.textContent =
          'Added';


        /*
         * Now refresh the actual cart drawer.
         */

        return refreshCartDrawer();

      })


      /* -------------------------------------------------
         OPEN DRAWER AFTER HTML UPDATE
      ------------------------------------------------- */

      .then(function () {

        /*
         * Small delay is intentional.
         *
         * It allows the browser to finish
         * replacing the drawer contents.
         */

        setTimeout(function () {

          openCartDrawer();

        }, 100);


        /*
         * Reset button text.
         */

        setTimeout(function () {

          button.classList.remove(
            'is-added'
          );

          button.textContent =
            originalText;

        }, 1500);

      })


      /* -------------------------------------------------
         ERROR
      ------------------------------------------------- */

      .catch(function (error) {

        console.error(
          'Zasta Add To Cart Error:',
          error
        );


        button.classList.remove(
          'is-loading'
        );

        button.classList.remove(
          'is-added'
        );

        button.classList.add(
          'is-error'
        );


        button.textContent =
          error &&
          error.description
            ? error.description
            : 'Unable To Add';


        setTimeout(function () {

          button.classList.remove(
            'is-error'
          );

          button.textContent =
            originalText;

        }, 2500);

      });

    }
  );

})();
  } catch(e) { console.error(e); }
})();

})();
